const compactUnitLabels: Record<string, string> = {
  piece: 'buc.',
  bucata: 'buc.',
  bucată: 'buc.',
  kilogram: 'kg',
  gram: 'g',
  tonne: 't',
  tona: 't',
  tonă: 't',
  liter: 'l',
  litre: 'l',
  litru: 'l',
  milliliter: 'ml',
  millilitre: 'ml',
  mililitru: 'ml',
  box: 'cutie',
  cutie: 'cutie',
  bag: 'sac',
  sac: 'sac',
  package: 'pachet',
  pachet: 'pachet',
};

export const normalizeUnitType = (value: string) => value.trim().replace(/^per\s+/i, '');

export const formatUnitType = (value: string) => {
  const normalized = normalizeUnitType(value);
  return compactUnitLabels[normalized.toLocaleLowerCase('ro')] || normalized;
};

const priceUnitLabels: Record<string, string> = {
  ...compactUnitLabels,
  mililiter: 'ml',
  dozen: 'duz.',
  duzina: 'duz.',
  hundred: '100 buc.',
  suta: '100 buc.',
  meter: 'm',
  metre: 'm',
  metru: 'm',
  'square metre': 'm²',
  'metru patrat': 'm²',
  'cubic metre': 'm³',
  'metru cub': 'm³',
  hectare: 'ha',
  hectar: 'ha',
};

export const formatPriceUnitType = (value: string, punctuated = true) => {
  const normalized = value.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    .toLowerCase().replace(/^per\s+/, '').trim();
  const label = priceUnitLabels[normalized];
  return label ? (punctuated ? label : label.replace(/\.$/, '')) : normalized;
};

const priceNumberFormat = new Intl.NumberFormat('ro-RO', { maximumFractionDigits: 2 });

/** "12,5 lei/kg" — the compact price label shared by product cards and the chat product panel. */
export const formatProductPrice = (price: { price: number; currency: string; unitType: string }) => {
  const currency = price.currency === 'RON' ? 'lei' : price.currency;
  return `${priceNumberFormat.format(price.price)} ${currency}/${formatPriceUnitType(price.unitType)}`;
};
